// extracted by mini-css-extract-plugin
export default {"container":"NewsTemplate_container__GR2Hm","main":"NewsTemplate_main__KxG7K"};